import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="foot-grid">
        <div>
          <div className="foot-logo">
            <img src="/images/logo.png" alt="MyCollegeBuddy Logo" className="footer-logo" />
          </div>
          <p className="foot-desc">
            Your trusted companion in the journey to MBBS — helping 2,500+ students find the right
            medical college in India and abroad since 2019.
          </p>
          <div className="foot-socials">
            <a href="https://www.facebook.com/mycollegebuddy01/" target="_blank" rel="noreferrer" className="soc" aria-label="Facebook">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href="https://www.instagram.com/mycollegebuddy/?hl=en" target="_blank" rel="noreferrer" className="soc" aria-label="Instagram">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="https://www.youtube.com/@mycollegebuddy" target="_blank" rel="noreferrer" className="soc" aria-label="YouTube">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon fill="white" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>
            </a>
            <a href="https://in.linkedin.com/company/my-college-buddy" target="_blank" rel="noreferrer" className="soc" aria-label="LinkedIn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
        </div>

        <div className="foot-col">
          <h5>Quick Links</h5>
          <ul>
            <li><a href="#features">Why Choose Us</a></li>
            <li><a href="#nmc-guidelines">NMC Guidelines</a></li>
            <li><a href="#documents">Documents Required</a></li>
            <li><a href="#process">Our Process</a></li>
            <li><a href="#faq">FAQ</a></li>
            <li><a href="#home">Apply Free</a></li>
          </ul>
        </div>

        <div className="foot-col">
          <h5>Study Destinations</h5>
          <ul>
            <li><a href="https://studyabroad.mycollegebuddy.com/mbbs-in-russia" target="_blank" rel="noreferrer">MBBS in Russia</a></li>
            <li><a href="https://studyabroad.mycollegebuddy.com/mbbs-in-philippines" target="_blank" rel="noreferrer">MBBS in Philippines</a></li>
            <li><a href="https://studyabroad.mycollegebuddy.com/mbbs-in-kazakhstan" target="_blank" rel="noreferrer">MBBS in Kazakhstan</a></li>
            <li><a href="https://studyabroad.mycollegebuddy.com/mbbs-in-georgia" target="_blank" rel="noreferrer">MBBS in Georgia</a></li>
            <li><a href="https://studyabroad.mycollegebuddy.com/mbbs-in-bangladesh" target="_blank" rel="noreferrer">MBBS in Bangladesh</a></li>
          </ul>
        </div>

        <div className="foot-col">
          <h5>Contact Us</h5>
          <ul>
          
            <li><a href="mailto:contact@mycollegebuddy.com">contact@mycollegebuddy.com</a></li>
           
          </ul>
        </div>
      </div>

      <div className="foot-bottom">
        <span>© 2026 MyCollegeBuddy. All rights reserved.</span>
        <div className="foot-bottom-links">
          <a href="https://mycollegebuddy.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
          <a href="https://mycollegebuddy.com/terms" target="_blank" rel="noreferrer">Terms of Use</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;